import localStorageUser from 'utils/localStorageUser';

import { CHANGE_LOCALE } from './constants';

export function changeLocale(languageLocale) {
  localStorageUser.setLanguageUserStorage(languageLocale);
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}
